import React, { Component } from 'react';
import { connect } from 'react-redux';
import isWebview from '@gerenciatd/next13.utils.common.is-webview';
import getCookie from '@gerenciatd/next13.utils.common.get-cookie';
import setCookie from '@gerenciatd/next13.utils.common.set-cookie';
import { actions as mainActions } from '@/bit/reducers/next13.reducers.main-reducer'
import sendGaPageEvent from '@gerenciatd/next13.utils.metrics.send-ga-page-event'
import {
  getTabId,
  getUserPersistedInfo,
  generatePageId,
  createPageEventObject, extractUserProperties, extractMainProperties,
} from './utils';

const EVENT_TYPES = {
  VIEW: 'view',
  LOADED: 'printed',
}

class RouteHandler extends Component {
  getContextSeoInfo = () => {
    let contextSeoMeta = '';
    let pageName = '';
    let pageProductName = '';
    try {
      contextSeoMeta = document.querySelector('meta[id="context_seo_meta"]').getAttribute('content');
    } catch(error) {}
    try {
      pageName = document.querySelector('meta[id="page_name"]').getAttribute('content');
    } catch(error) {}
    try {
      pageProductName = document.querySelector('meta[id="product_name"]').getAttribute('content');
    } catch(error) {}

    const res = {
      contextSeoMeta,
      pageName,
      pageProductName,
    }

    return res;
  }

  getReadyGA = () => {
    let ga = getCookie('_ga') || '';
    const gaTokkens = ga.split('.');
    if (gaTokkens.length > 2) {
      ga = gaTokkens.slice(2).join('.');
    }
    return ga;
  }


  getSessId = () => {
    let sessId = getCookie('_mc_sessid');
    if(!sessId){
      sessId = `${new Date().getTime()}`;
      setCookie('_mc_sessid', sessId, undefined, '.movistar.es');
    }
    return sessId
  }

  sendGaConfig = (context) => {
    const data = createPageEventObject(context);
    // inicializo config
    const mainProperties = extractMainProperties(data);
    const userProperties = extractUserProperties(data);

    // zonas
    let zipcode = this.geo && this.geo.zone ? this.geo.zone : "";
    if (zipcode === "ZR") {
      zipcode = "regulada";
    }
    if (zipcode === "ZL") {
      zipcode = "libre";
    }
    if (zipcode === "ZM") {
      zipcode = "mixta";
    }

    const logado = (context && (context.userIdPartyHash || context.userCUCFijoHash || context.userCUCMovilHash || context.userCUCPrepagoHash)) || ""
    gtag("config", `${process.env.NEXT_PUBLIC_GTM_ID}`, {
      "page_variation": logado ? "cliente":"no-cliente",
      transport_url: "https://landings.dev.col.movistar.es",
      first_party_collection: true,
      ...mainProperties,
      ...userProperties,
      "zip-code": zipcode,
    })

    this.sendPageEvent(context, EVENT_TYPES.LOADED);
  }

  updateConsent = ({context, callBack}) => {
    try {
      let optanon = getCookie("OptanonConsent");
      optanon = decodeURIComponent(optanon);
      let ad_storage = optanon.indexOf("C0004:1") !== -1 ? "granted" : "denied";
      let analytics_storage = optanon.indexOf("C0002:1") !== -1 ? "granted" : "denied";
      if (isWebview()){
        let retries = 10;
        let waitWB = setInterval(async () => {
          retries--;
          if (window.webviewBridge){
            retries = -1;
            let status = await window.webviewBridge.getAttStatus();
            if (status != null) {
              ({status} = status);
              // cogemos el valorcito, sino me quedo los que ya
              ad_storage = status;
              analytics_storage = status;
            } 

            if (ad_storage !== "denied" || analytics_storage !== "denied") {
              gtag("consent", "update", {
                "ad_storage": ad_storage,
                "analytics_storage": analytics_storage,
              });
            }
            callBack(context)
          } 
          if (retries<0) {
            clearInterval(waitWB)
          }
        },100)
      } else {
        // evento update
        if (ad_storage !== "denied" || analytics_storage !== "denied") {
          gtag("consent", "update", {
            "ad_storage": ad_storage,
            "analytics_storage": analytics_storage,
          });
        }
        callBack(context)
      }
    } catch(e) {
      console.log(e)
    }
  }


  sendPageEvent = async (context, eventType) => {
    try {
      // Event view, buen punto para el set general de ga
      if (eventType === EVENT_TYPES.VIEW) {
        //1) updateConsent =>> 2) sendGaConfig
        this.updateConsent({context, callBack: this.sendGaConfig})
        //3) meantime render app
        let finishFromGtag = false;
        context.clientIDs.sessionId = '';
        gtag('get', 'G-J1GJWFY08P', 'session_id', (sessionId) => {
          context.clientIDs.sessionId = sessionId;
          finishFromGtag = true;
          const {setContextData} = this.props;
          setContextData(context);
        });
        if(!finishFromGtag){
          const {setContextData} = this.props;
          setContextData(context);
        }
      } else {
        sendGaPageEvent(eventType);
      }
    } catch(error) {
      console.error(error);
    }
  }

  handleRouteLanding = async (...args) => {   
    const context = this.createInitialContextObj();
    this.sendPageEvent(context, EVENT_TYPES.VIEW);
    if (`${process.env.NEXT_PUBLIC_ENV_NAME}` !== 'dev') {
      import('@gerenciatd/next13.adabyron.misc.ping-cms').then(pingModule => {
        // ping a cms page
        pingModule = pingModule.default;
        let ping = new pingModule({ context });
        ping.sendPingCmsPage();
      });
    }
  }

  createInitialContextObj = () => {
    const  { context: ssrContext, checkCPAndSetZones, setCpParams, setUserPqInfo } = this.props;
    let initialContextData = {}
    let geo = null;
    let userPq = null;
    const persistedInfo = {...getUserPersistedInfo()};
    let userContextInfo = {}
    if (persistedInfo) {
      // si hay persisted info me lo quedo
      userContextInfo = {...persistedInfo}
        // no tengo info de geo
        if (!userContextInfo.geo && userContextInfo && (!userContextInfo.geo || !userContextInfo.geo.postalCode)) {
          checkCPAndSetZones({cp: ''});
        } else {
          // si tiene geo persistido me lo quedo
          geo = {
            cp: (userContextInfo.geo && userContextInfo.geo.postalCode) || '28030', 
            zone: (userContextInfo.geo && userContextInfo.geo.zone)  || 'ZL', 
            municipio: (userContextInfo.geo && userContextInfo.geo.municipio)  || '', 
            businessZones: (userContextInfo.geo && userContextInfo.geo.businessZones)  || [],
          }
        }
    } else {
      checkCPAndSetZones({cp: ''});
      userContextInfo = {
        userCUCFijoHash: "",
        userCUCMovilHash: "",
        userCUCPrepagoHash: "",
        userIdPartyHash:  "",
        userName:  "",
        userType: "",
      }
    }

    try {
      const pageId = generatePageId();
      window.pageId = pageId;

      initialContextData = {
        ...ssrContext,
        numLocationChanges: 0,
        tabId: getTabId(),
        pageWebCode: null,
        pageName: null,
        pageWebName: null,
        pageProductCode: null,
        pageProductName: null,
        clientIDs: {
          pageId,
          ga: this.getReadyGA(),
          sessId: this.getSessId(),
        },
        userType: '',
        pageSegment: `${process.env.NEXT_PUBLIC_ENV_SEGMENT}`,
        contextURL: window.location.href,
        subseg: false,
        userPriority: false,
        version: `${process.env.NEXT_PUBLIC_VERSION_JS}` || 'unknown',
        ...this.getContextSeoInfo(),
        ...persistedInfo,
        ...userContextInfo,
      };

    // se lo mando a redux
    if(geo){ setCpParams(geo); }
    if (initialContextData.userPq){
      userPq = initialContextData.userPq;
      const userFlags = initialContextData.userFlags || []
      setUserPqInfo({
        userPq,
        userFlags,
      });
    } else {
      setUserPqInfo({
        userPq: {},
        userFlags: [],
      });
    }

    // elimino de context
    if (initialContextData && initialContextData.geo){
      this.geo = initialContextData.geo
      delete initialContextData.geo;
    }
    if (initialContextData && initialContextData.userPq){
      // ante de eliminar lo dejo da nivel de clase para algún dia en pagina
      this.userPq = initialContextData.userPq
      delete initialContextData.userPq;
      delete initialContextData.userFlags
    }         
      
      return initialContextData;
    } catch (error) {
      console.error(error)
      return initialContextData;
    }
  }

  componentDidMount(){  
    this.handleRouteLanding();
  }

  render(){
    return <></>
  }
}


const mapStateToProps = (state) => ({
  context: state.main.context,
});

const mapDispatchToProps = (dispatch) => ({
  setCpParams: data => dispatch(mainActions.setCpParams(data)),
  setContextData: newData => dispatch(mainActions.setContextData(newData)),
  checkCPAndSetZones: (data) => dispatch(mainActions.checkCPAndSetZones(data)),
  setUserPqInfo:  (data) => dispatch(mainActions.setUserPqInfo(data)),
});


export default (connect(mapStateToProps, mapDispatchToProps)(RouteHandler))
